import React, { memo, useContext } from 'react';

import { AppContext } from 'App';

import './Testimonials.scss';

const Testimonials = () => {
  const { pageData } = useContext(AppContext);
  const { mainTitle, title, paragraph, video_url, img_url } = pageData?.testimonials;

  return (
    <section id="testimonialSection" className="testimonial">
      <div className="container">
        <h2>{mainTitle}</h2>
        <div className="video_box">
          <div className="video">
            <iframe
              width="100%"
              height="100%"
              postet="https://assets.airtel.in/teams/simplycms/web/images/videoThumbnail_090821.png"
              src={video_url}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div className="tesimonials_content">
            <figure>
              <img src={img_url} alt="UP Police" />
            </figure>
            <h4>{title}</h4>
            <p>{paragraph}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(Testimonials);
